<template>
  <div>
    <el-button type="primary" @click="openDialog">打开地图</el-button>

    <el-dialog title="选择位置" :visible.sync="dialogVisible" width="80%" top="5vh" :append-to-body="true" :close-on-click-modal="false">
      <div id="map-container" style="width: 100%; height: 500px;"></div>
      <div style="display: flex; justify-content: space-between;">
        <el-input v-model="searchQuery" placeholder="搜索地点" @keyup.enter="searchPlace" style="flex: 0.9;"></el-input>
        <el-button type="primary" @click="searchPlace">搜索</el-button>
      </div>
      <div>
        <span>地址: {{ selectedAddress }}</span>
        <br>
        <span>经纬度: {{ selectedLocation }}</span>
      </div>
      <div style="text-align: right;">
        <el-button type="primary" @click="submitData">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getGdKey} from "../../api/userMG";

export default {
  data() {
    return {
      dialogVisible: false,
      map: null,
      searchQuery: '',
      selectedAddress: '',
      selectedLocation: '',
      marker: null,
    };
  },
  methods: {
    openDialog() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.initMap();
      });
    },
    initMap() {
      // 获取浏览器定位

      // 初始化地图
      this.map = new AMap.Map('map-container', {
        zoom: 13, // 缩放级别
        // center 不设置，默认定位到当前市
        // center: [120.15279, 30.26744] // 中心点坐标
      });

      // 添加点击地图事件
      this.map.on('click', (e) => {
        this.selectedLocation = [e.lnglat.getLng(), e.lnglat.getLat()];
        this.reverseGeocode(this.selectedLocation);
        this.addMarker(this.selectedLocation);
        // this.getAddress(e.lnglat);
      });
    },
    searchPlace() {
      if (this.searchQuery) {
        const placeSearch = new AMap.PlaceSearch({
          pageSize: 5,
          pageIndex: 1,
          city: '全国'
        });
        placeSearch.search(this.searchQuery, (status, result) => {
          if (status === 'complete' && result.poiList.pois.length > 0) {
            const location = result.poiList.pois[0].location;
            this.selectedLocation = [location.lng,location.lat];
            this.selectedAddress = result.poiList.pois[0].name;
            this.map.setCenter(this.selectedLocation);
            this.addMarker(this.selectedLocation);
          }
        });
      }
    },
    addMarker(location) {
      if (this.marker) {
        this.marker.setMap(null);
      }
      this.marker = new AMap.Marker({
        position: location,
        map: this.map,
      });
    },
    reverseGeocode(location) {
      const geocoder = new AMap.Geocoder({
        city: '全国',
      });

      geocoder.getAddress(location, (status, result) => {
        if (status === 'complete' && result.regeocode) {
          this.selectedAddress = result.regeocode.formattedAddress;
        }
      });
    },
    submitData() {
      if (this.selectedAddress && this.selectedLocation) {
        var res = {
          selectedAddress: this.selectedAddress,
          selectedLocation: this.selectedLocation
        }
        this.$emit('addressData', res);
        this.dialogVisible = false;
      } else {
        this.$message.error('请点击地图区域选择位置...')
      }
    }
  },
  mounted() {
    getGdKey().then(res => {
      if (res.code == 200) {
        // 加载高德地图API    '119405f1a96017d6b8028befc9776996'
        const key = res.data;
        const script = document.createElement('script');
        script.src = `https://webapi.amap.com/maps?v=1.4.15&key=${key}&plugin=AMap.PlaceSearch,AMap.Geocoder`;
        script.onload = () => {
          this.initMap();
        };
        document.head.appendChild(script);
      } else {
        this.$message.error('获取失败');
      }
    })
  },
};
</script>

<style scoped>
#map-container {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/mapDialog/mapDialog.vue